

export default class UpdateAnimationRequest  {
	Id?: string = '';
	Name?: string = '';
	Base64Content?: string = '';
	constructor(obj?: Partial<UpdateAnimationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
